import { ELEMENTS as BUTTON_ELEMENTS } from '@lumapps/wrex-button/plugin/html/deserialize/elements';
import { ELEMENTS as CODE_BLOCK_ELEMENTS } from '@lumapps/wrex-code-block/plugin/html/deserialize/elements';
import { ELEMENTS as COLUMNS_ELEMENTS } from '@lumapps/wrex-columns/plugin/html/deserialize/elements';
import { ELEMENTS as EMBEDDED_MAP_ELEMENTS } from '@lumapps/wrex-embedded-map/plugin/html/deserialize/elements';
import { ELEMENTS as EMBEDDED_VIDEO_ELEMENTS } from '@lumapps/wrex-embedded-video/plugin/html/deserialize/elements';
import { ELEMENTS as IMAGE_ELEMENTS } from '@lumapps/wrex-enhanced-image/plugin/html/deserialize/elements';
import { ELEMENTS as FILE_ELEMENTS } from '@lumapps/wrex-file/plugin/html/deserialize/elements';
import { HTMLPasteOptions } from '@lumapps/wrex-html-paste/types';
import { ELEMENTS as IFRAME_ELEMENTS } from '@lumapps/wrex-iframe/plugin/html/deserialize/elements';
import { ELEMENTS as INFO_PANEL_ELEMENTS } from '@lumapps/wrex-info-panel/plugin/html/deserialize/elements';
import { ELEMENTS as LINK_PREVIEW_ELEMENTS } from '@lumapps/wrex-link-preview/plugin/html/deserialize/elements';
import { ELEMENTS as LINK_ELEMENTS } from '@lumapps/wrex-link/plugin/html/deserialize/elements';
import { ELEMENTS as LIST_ELEMENTS } from '@lumapps/wrex-list/plugin/html/deserialize/elements';
import { ELEMENTS as PLAY_VIDEO_ELEMENTS } from '@lumapps/wrex-play-video/plugin/html/deserialize/elements';
import { ELEMENTS as QUOTE_ELEMENTS } from '@lumapps/wrex-quote/plugin/html/deserialize/elements';
import { ELEMENTS as TABLE_ELEMENTS } from '@lumapps/wrex-table/plugin/html/deserialize/elements';
import { HEADING, HEADLINE, PARAGRAPH, SUBTITLE, TITLE } from '@lumapps/wrex-typography/constants';
import { ELEMENTS as TYPOGRAPHY_ELEMENTS } from '@lumapps/wrex-typography/plugin/html/deserialize/elements';
import { MARKS as MARKS_ELEMENTS } from '@lumapps/wrex-typography/plugin/html/deserialize/marks';
import { ELEMENTS as USER_MENTION_ELEMENTS } from '@lumapps/wrex-user-mention/plugin/html/deserialize/elements';

// Element order matters: more specific converters (e.g. HEADING) must come before
// generic ones (e.g. PARAGRAPH) so that `<p role="heading">` matches HEADING first.
const HTML_PASTE_ELEMENTS = {
    ...TYPOGRAPHY_ELEMENTS,
    ...CODE_BLOCK_ELEMENTS,
    ...INFO_PANEL_ELEMENTS,
    ...LIST_ELEMENTS,
    ...IMAGE_ELEMENTS,
    ...USER_MENTION_ELEMENTS,
    ...LINK_PREVIEW_ELEMENTS,
    ...LINK_ELEMENTS,
    ...TABLE_ELEMENTS,
    ...QUOTE_ELEMENTS,
    ...EMBEDDED_MAP_ELEMENTS,
    ...EMBEDDED_VIDEO_ELEMENTS,
    ...IFRAME_ELEMENTS,
    ...PLAY_VIDEO_ELEMENTS,
    ...FILE_ELEMENTS,
    ...BUTTON_ELEMENTS,
    ...COLUMNS_ELEMENTS,
} as const;

const HTML_PASTE_MARKS = {
    ...MARKS_ELEMENTS,
} as const;

export interface HtmlPasteConfig {
    elements: (keyof typeof HTML_PASTE_ELEMENTS)[];
    marks: (keyof typeof HTML_PASTE_MARKS)[];
    maxHeadingLevel?: number;
}

export const getHtmlPasteOptions = ({ elements, marks, maxHeadingLevel }: HtmlPasteConfig): HTMLPasteOptions => {
    const elementsSet = new Set(elements);
    const htmlPasteElements = Object.entries(HTML_PASTE_ELEMENTS)
        .filter(([key]) => elementsSet.has(key as keyof typeof HTML_PASTE_ELEMENTS))
        .map(([, value]) => value);
    const htmlPasteMarks = marks.map((mark) => HTML_PASTE_MARKS[mark]);

    return {
        elements: htmlPasteElements,
        marks: htmlPasteMarks,
        allowedAlignments: [PARAGRAPH, HEADING, HEADLINE, TITLE, SUBTITLE],
        defaultBlockType: PARAGRAPH,
        maxHeadingLevel,
    };
};
